if ($("body").find(".slider-gallery.products-slider").length > 0) {
  setTimeout(function(){
    var flkty = new Flickity('.progress_first .slider-gallery.products-slider');
    var progressBar = document.querySelector('.progress_first .progress-bar')
    flkty.on( 'scroll', function( progress ) {
      progress = Math.max( 0, Math.min( 1, progress ) );
      progressBar.style.width = progress * 100 + '%';
    });
    var flkty2 = new Flickity('.progress_second .slider-gallery.products-slider');
    var progressBar2 = document.querySelector('.progress_second .progress-bar')
    flkty2.on( 'scroll', function( progress2 ) {
      progress2 = Math.max( 0, Math.min( 1, progress2 ) );
      progressBar2.style.width = progress2 * 100 + '%';
    });
    var flkty3 = new Flickity('.progress_third .slider-gallery.products-slider');
    var progressBar3 = document.querySelector('.progress_third .progress-bar')
    flkty3.on( 'scroll', function( progress3 ) {
      progress3 = Math.max( 0, Math.min( 1, progress3 ) );
      progressBar3.style.width = progress3 * 100 + '%';
    });
  }, 2000);
}
$('.home_bar_slider').owlCarousel({
  margin: 0, 
  nav: false,
  dots: false,
  loop: false,
  autoplay:false,
  responsive: {
    0: {
      items:1,
      loop: true
    },
    481: {
      items:2
    },
    601: {
      items: 2
    },
    1000: {
      items: 5
    }
  }
});
$('.home_collection_slider').owlCarousel({
  margin: 0, 
  nav: false,
  dots: false,
  loop: false,
  autoplay:false,
  responsive: {
    0: {
      items:1,
      loop: true,
      dots: true
    },
    481: {
      items:3
    },
    601: {
      items: 3
    },
    1000: {
      items: 3
    }
  }
});
$('.wear_it_slide').owlCarousel({
  margin: 0, 
  nav: false,
  dots: false,
  loop: false,
  autoplay:false,
  responsive: {
    0: {
      items:1,
      loop: true,
      dots: true
    },
    481: {
      items:1
    },
    601: {
      items: 1
    },
    1000: {
      items: 1
    }
  }
});

$('.home_test_slider').on('initialized.owl.carousel changed.owl.carousel', function(e) {
  if (!e.namespace)  {
    return;
  }
  var carousel = e.relatedTarget;
  $('.slider-counter').text(carousel.relative(carousel.current()) + 1 + '/' + carousel.items().length);
}).owlCarousel({
  items: 1,
  loop:false,
  margin:0,
  nav:true,
  dots: false
});
$(document).ready(function() {
  $(function() {
    var Accordion = function(el, multiple) {
      this.el = el || {};
      this.multiple = multiple || false;

      var links = this.el.find('.article-title');
      links.on('click', {
        el: this.el,
        multiple: this.multiple
      }, this.dropdown)
    }

    Accordion.prototype.dropdown = function(e) {
      var $el = e.data.el;
      $this = $(this),
        $next = $this.next();

      $next.slideToggle();
      $this.parent().toggleClass('open');

      if (!e.data.multiple) {
        $el.find('.accordion-content').not($next).slideUp().parent().removeClass('open');
      };
    }
    var accordion = new Accordion($('.accordion-container'), false);
  });
if ($("body").find(".tabs_nav").length > 0) {
  var top = $('.tabs_nav').offset().top;
  function sticktothetop() {
    var window_top = $(window).scrollTop();
    if (window_top >= top) {
      $('.tabs_nav').addClass('tab_sticky');
    } else {
      $('.tabs_nav').removeClass('tab_sticky');
    }
  }
  $(function() {
    $(window).scroll(sticktothetop);
    sticktothetop();
  });

}
}); 
$(document).ready(function() {
  $('.product_name.title').html(function(i, v){
    if (v.indexOf('-') > -1){
      var html = v.split('-');

      return '<span>' + html[0] + '</span>' + html[1]
    }
  });
});


$(document).ready(function () {
  $(".bundle_select").change(function () {
    var varid = $(this).children("option:selected").attr('data-varid');
    $(this).parents(".price_w_option").find(".bundle_product").attr("value",varid);
  });
});